module.exports = __webpack_public_path__ + "static/img/slide2.b68750e0.jpg";